import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import GlobalTable from '../components/GlobalTable';
import { useLazyTable } from '../hooks/useLazyTable';
import axiosInstance from '../services/axiosInstance';
import { handleApiError } from '../components/apiErrorHandler';
import { useBreadcrumbs } from '../contexts/BreadcrumbContext';

const SupplierPayments = () => {
  const [payments, setPayments] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const { lazyParams, onPage, onSort, onFilter, queryParams } = useLazyTable({ rows: 15 });
  const [loading, setLoading] = useState(false);
  const { push, beginDrilldown } = useBreadcrumbs();
  const navigate = useNavigate();

  const loadPayments = () => {
    setLoading(true);
    axiosInstance
      .get('/api/supplier-payments/', { params: queryParams })
      .then((res) => {
        setPayments(res.data.results || []);
        setTotalRecords(res.data.count || 0);
      })
      .catch(handleApiError)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadPayments();
  }, [queryParams]);

  const statusBodyTemplate = (row) => {
    let sev = 'info';
    switch (row.status) {
      case 'completed':
        sev = 'success';
        break;
      case 'pending':
        sev = 'warning';
        break;
      case 'settled':
        sev = 'success';
        break;
      case 'cancelled':
        sev = 'danger';
        break;
      default:
        sev = 'info';
    }
    const label = (row.status || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    return <Tag value={label || '-'} severity={sev} />;
  };

  const columns = [
    {
      Header: 'ID',
      accessor: 'id',
    },
    {
      Header: 'Move Order',
      accessor: 'mo_number',
      filtered: true,
      bodyTemplate: (row) => (
            <span
                style={{ color: '#2563eb', cursor: 'pointer' }}
                onClick={() =>{
                    beginDrilldown();
                    navigate('/moveorders', {
                        state: {moId: row.move_order}
                    });
                    push({
                        label: `Supplier Payments`,
                        path: '/supplier-payments',
                    });
                    push({
                        label: `Move Orders`,
                        path: '/moveorders',
                    });
                    push({
                        label: `Order: ${row.mo_number}`,
                        path: `/moveorders`,
                        state: {moId: row.move_order}
                    });
                }}
            >
                {row.mo_number}
            </span>
            )
    },
    {
      Header: 'Invoice ID',
      accessor: 'invoice',
      filtered: true,
      bodyTemplate: (row) => (row.invoice ? `INV#${row.invoice}` : '—'),
    },
    {
      Header: 'Supplier',
      accessor: 'supplier_name',
      filtered: true,
    },
    {
      Header: 'Paid By',
      accessor: 'paid_by_name',
      filtered: true,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      dataType: 'currency',
    },
    {
      Header: 'Method',
      accessor: 'payment_method',
      filtered: true,
    },
    {
      Header: 'Paid At',
      accessor: 'paid_at',
      dataType: 'date',
      sortable: true,
    },
    {
      Header: 'Status',
      accessor: 'status',
      filtered: true,
      bodyTemplate: statusBodyTemplate,
    },
    {
      Header: 'Remarks',
      accessor: 'remarks',
      filtered: true,
    },
  ];

  const headerAction = (
    <Button
      type="button"
      icon="pi pi-refresh"
      label="Refresh"
      outlined
      onClick={loadPayments}
      className="w-full sm:w-auto"
    />
  );

  return (
    <div className="containers">
      <GlobalTable
        columns={columns}
        data={payments}
        loading={loading}
        tabletitle="Supplier Payments"
        showEditColumn={false}
        lazy
        totalRecords={totalRecords}
        lazyParams={lazyParams}
        onPage={onPage}
        onSort={onSort}
        onFilter={onFilter}
        headerAction={headerAction}
      />
    </div>
  );
};

export default SupplierPayments;